import { useEffect, useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";

import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { KeyboardShortcutSignalType, PubsubMessageTypeType } from "shared/types";
import { localSelectors } from "store";
import { clearPubsubMessage, setKeyboardShortcutSignal } from "store/reducers/local";

const CONFETTI_DURATION = 5000;

function ConfettiObserver() {
  const dispatch = useAppDispatch();
  const pubsubMessage = useAppSelector(localSelectors.selectPubsubMessage());
  const keyboardShortcutSignal = useAppSelector(localSelectors.selectKeyboardShortcutSignal());
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout | undefined;

    if (
      pubsubMessage?.type === PubsubMessageTypeType.RUN_CONFETTI ||
      keyboardShortcutSignal === KeyboardShortcutSignalType.RunConfetti
    ) {
      setShowConfetti(true);
      timeout = setTimeout(() => {
        setShowConfetti(false);
        if (keyboardShortcutSignal === KeyboardShortcutSignalType.RunConfetti) {
          dispatch(setKeyboardShortcutSignal({ signal: KeyboardShortcutSignalType.None }));
        } else {
          dispatch(clearPubsubMessage());
        }
      }, CONFETTI_DURATION - 800); // slightly less than confetti duration to make repeat confetti feel snappier
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [dispatch, keyboardShortcutSignal, pubsubMessage?.type]);

  if (showConfetti) {
    return (
      <div className="absolute top-0 right-0 bottom-0 left-0" style={{ pointerEvents: "none" }}>
        <div className="absolute-center">
          <ConfettiExplosion
            colors={[
              "#0A78BF",
              "#1596B4",
              "#33AB6F",
              "#8EA604",
              "#F0B91E",
              "#F0871E",
              "#DF2F26",
              "#A5417D",
              "#5B3E97",
              "#322864",
            ]}
            duration={CONFETTI_DURATION}
            force={0.8}
            height="150vh"
            particleCount={250}
            width={window.innerWidth + 300}
            zIndex={9999}
          />
        </div>
      </div>
    );
  }

  return null;
}

export { ConfettiObserver };
